import { fm } from 'Components/FormatMessage';
import { Container, Item } from 'Components/Grid';
import HistoryRow from 'Components/HistoryRow';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import * as React from 'react';
import { formatPartialDate } from 'Utility/date';
import { newButton } from '../../../../utils/functions';

import type { IHistoryContext } from 'Containers/FormContextHandler';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<'sleepApneaSeverity'>[] = [];
const SleepApneaSeverityHistory = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
}: IHistoryContext<IDocumentWithTypeV2<'sleepApneaSeverity'>>): React.JSX.Element => {
  return (
    <HistoryRow
      headerText={fm('diagnosis.sleepApnea.sleepApneaSeverity.title')}
      rowButton={
        startEdit ? newButton('sleepApneaSeverity', startEdit({}, 'sleepApneaSeverity'), 'general.new', 15) : undefined
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <Item xs={12}>
            <Container>
              <Item xs={5}>{fm('general.date')}</Item>
              <Item xs={7}>{fm('diagnosis.sleepApnea.sleepApneaSeverity.severity')}</Item>
            </Container>
          </Item>
        }
        contentFormat={d => (
          <Item xs={12}>
            <Container>
              <Item xs={5}>{d.date ? formatPartialDate(d.date) : '-'}</Item>
              <Item xs={5}>{d.severity ? fm(`diagnosis.sleepApnea.sleepApneaSeverity.opts.${d.severity}`) : '-'}</Item>
              <Item xs={2}>{startEdit ? <HistoryRowControls document={d} startEdit={startEdit} /> : null}</Item>
            </Container>
          </Item>
        )}
        collapse={false}
      />
    </HistoryRow>
  );
};

export default SleepApneaSeverityHistory;
